export default "__VITE_ASSET__D1pLQ13___"